var $ef04b9b182d03210$exports = {};
$ef04b9b182d03210$exports = {
    "clear": `Puhasta`,
    "invalid": `(kehtetu)`,
    "loading": `Laadimine...`,
    "noResults": `Tulemusi pole`,
    "valid": `(kehtiv)`
};


export {$ef04b9b182d03210$exports as default};
//# sourceMappingURL=et-EE.mjs.map
